// extracted by mini-css-extract-plugin
module.exports = {"total":"GraphQLQuerySql_total__18ERz"};